var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useState } from 'react';
import OutlinedDown from 'acud-icon/lib/icons/OutlinedDown';
import OutlinedUp from 'acud-icon/lib/icons/OutlinedUp';
import DropDown from '../dropdown/dropdown';
import { ConfigContext } from '../config-provider';
const BreadcrumbItem = (_a) => {
    var { prefixCls: customizePrefixCls, separator = '/', children, overlay, dropdownProps } = _a, restProps = __rest(_a, ["prefixCls", "separator", "children", "overlay", "dropdownProps"]);
    const [visible, setVisible] = useState(false);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
    const handleVisibleChange = useCallback(visible => {
        setVisible(visible);
    }, []);
    /** If overlay is have Wrap a DropDown */
    const renderBreadcrumbNode = (breadcrumbItem) => {
        if (overlay) {
            return (<DropDown overlay={overlay} visible={visible} placement="bottomCenter" overlayClassName={`${prefixCls}-dropdown`} {...dropdownProps} onVisibleChange={handleVisibleChange}>
                    <span className={`${prefixCls}-overlay-link`}>
                        {breadcrumbItem}
                        {visible ? <OutlinedUp /> : <OutlinedDown />}
                    </span>
                </DropDown>);
        }
        return breadcrumbItem;
    };
    let link;
    if ('href' in restProps) {
        link = (<a className={`${prefixCls}-link`} {...restProps}>
                {children}
            </a>);
    }
    else {
        link = (<span className={`${prefixCls}-link`} {...restProps}>
                {children}
            </span>);
    }
    // wrap to dropDown
    link = renderBreadcrumbNode(link);
    if (children) {
        return (<span>
                {link}
                {separator && (<span className={`${prefixCls}-separator`}>{separator}</span>)}
            </span>);
    }
    return null;
};
BreadcrumbItem.__ACUD_BREADCRUMB_ITEM = true;
export default BreadcrumbItem;
